import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Post } from '../core/post';
import { DayComponent } from '../day/day.component';


@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {

  post: Post;

  constructor(
    private dialogRef: MatDialogRef<DayComponent>,
    @Inject(MAT_DIALOG_DATA) data) {

    this.post = data.post;
}

  ngOnInit(): void {
  }

}
